import React from 'react';
import { motion } from 'framer-motion';
export function Problema() {
  return <section id="problema" className="py-[60px] md:py-[80px]" data-id="element-189">
      <div className="max-w-[800px] mx-auto px-5" data-id="element-190">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[clamp(28px,5vw,42px)] font-black text-center leading-[1.2] mb-10" data-id="element-191">
          ¿En cuál de estos dos te reconocés?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10" data-id="element-192">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-2 border border-brand-blue-dark rounded-xl p-6 md:p-8" data-id="element-193">
            <h3 className="text-[17px] font-extrabold text-white mb-5 leading-[1.4]" data-id="element-194">
              Estudiás mucho y aun así...
            </h3>
            <div className="flex flex-col gap-4" data-id="element-195">
              <div className="flex items-start gap-3 text-[14px] text-brand-gray leading-[1.5]" data-id="element-196">
                <span className="text-[16px] shrink-0 mt-[1px]" data-id="element-197">❌</span>
                <span data-id="element-198">
                  Pasás horas leyendo y en el parcial se te va todo en blanco
                </span>
              </div>
              <div className="flex items-start gap-3 text-[14px] text-brand-gray leading-[1.5]" data-id="element-199">
                <span className="text-[16px] shrink-0 mt-[1px]" data-id="element-200">❌</span>
                <span data-id="element-201">Hacés resúmenes kilométricos que después no repasás</span>
              </div>
              <div className="flex items-start gap-3 text-[14px] text-brand-gray leading-[1.5]" data-id="element-202">
                <span className="text-[16px] shrink-0 mt-[1px]" data-id="element-203">❌</span>
                <span data-id="element-204">
                  Llegás a los finales agotado/a y con miedo de haber estudiado
                  lo que no entra
                </span>
              </div>
              <div className="flex items-start gap-3 text-[14px] text-brand-gray leading-[1.5]" data-id="element-205">
                <span className="text-[16px] shrink-0 mt-[1px]" data-id="element-206">❌</span>
                <span data-id="element-207">
                  Ves que otros sacan mejores notas estudiando menos y no
                  entendés por qué
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-navy-2 border border-brand-blue-dark rounded-xl p-6 md:p-8" data-id="element-208">
            <h3 className="text-[17px] font-extrabold text-white mb-5 leading-[1.4]" data-id="element-209">
              No sabés por dónde empezar...
            </h3>
            <div className="flex flex-col gap-4" data-id="element-210">
              <div className="flex items-start gap-3 text-[14px] text-brand-gray leading-[1.5]" data-id="element-211">
                <span className="text-[16px] shrink-0 mt-[1px]" data-id="element-212">❌</span>
                <span data-id="element-213">Abrís el PDF del programa y te congela la cabeza</span>
              </div>
              <div className="flex items-start gap-3 text-[14px] text-brand-gray leading-[1.5]" data-id="element-214">
                <span className="text-[16px] shrink-0 mt-[1px]" data-id="element-215">❌</span>
                <span data-id="element-216">
                  Dejás todo para último momento y estudiás con pánico
                </span>
              </div>
              <div className="flex items-start gap-3 text-[14px] text-brand-gray leading-[1.5]" data-id="element-217">
                <span className="text-[16px] shrink-0 mt-[1px]" data-id="element-218">❌</span>
                <span data-id="element-219">
                  Los TPs te comen el tiempo que necesitás para estudiar
                </span>
              </div>
              <div className="flex items-start gap-3 text-[14px] text-brand-gray leading-[1.5]" data-id="element-220">
                <span className="text-[16px] shrink-0 mt-[1px]" data-id="element-221">❌</span>
                <span data-id="element-222">
                  No importa cuánto te esforzés, nunca parece alcanzar
                </span>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[#1a2a1a] to-brand-green-dark border-[1.5px] border-brand-gold/40 rounded-xl p-7 text-center" data-id="element-223">
          <p className="text-[clamp(16px,2.5vw,20px)] font-bold leading-[1.6] text-white" data-id="element-224">
            La diferencia no es inteligencia. No es dedicación. Es el sistema.
            <br className="hidden sm:block" data-id="element-225" />
            <span className="text-brand-gold" data-id="element-226">Y el sistema se aprende.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}